import Image from "next/image";
import Link from "next/link";
import { ArticleCardProps } from "../types";
import {
  getGuideTextColor,
  getGuideBgColor,
  formatDate,
} from "@/components/koach/Shared/Helper";

const ArticleCard = ({ baseUrl, guide }: ArticleCardProps): JSX.Element => {
  const addedOn = formatDate(guide?.attributes?.addedOn);
  const bgColor = getGuideBgColor(
    guide?.attributes?.category?.data?.attributes?.slug
  );
  const textColor = getGuideTextColor(
    guide?.attributes?.category?.data?.attributes?.slug
  );
  const articleUrl = `${baseUrl}/${guide?.attributes?.slug}`;

  return (
    <div className="p-4 group flex flex-col gap-6 md:gap-7 rounded-3xl cursor-pointer relative transition duration-300 ease-in-out transform md:hover:shadow-2xl">
      <Link href={articleUrl} passHref>
        <a className="relative w-full pt-[57.5%] block group-hover:opacity-80">
          <Image
            src={
              guide?.attributes?.cover?.data?.attributes?.formats?.large?.url
            }
            alt={guide?.attributes?.title}
            priority
            layout="fill"
            objectFit="cover"
            className="rounded-tl-2xl rounded-tr-2xl"
          />
        </a>
      </Link>

      <div className="flex-1 w-full flex flex-col gap-6">
        <div className="w-full flex gap-5 items-center">
          <div
            className={`rounded-full ${bgColor} px-3 py-1 text-[11.5px] lg:text-[13px]`}
          >
            <p className={`font-bold ${textColor}`}>
              {guide?.attributes?.category?.data?.attributes?.name}
            </p>
          </div>
          <div className="border-r border-grey-200 py-3"></div>
          <p className="text-[14px] text-grey-400">
            {addedOn} · {guide?.attributes?.readingTime} min read
          </p>
        </div>

        <Link href={articleUrl} passHref>
          <a className="text-left text-lg md:text-xl lg:text-2xl font-semibold hover:underline">
            {guide?.attributes?.title}
          </a>
        </Link>

        <p className="text-left text-sm md:text-base text-grey-400">
          {guide?.attributes?.subTitle}
        </p>

        <Link href={articleUrl} passHref>
          <a className="text-left text-base font-semibold text-magenta mt-auto hover:underline">
            Read More
          </a>
        </Link>
      </div>
    </div>
  );
};

export default ArticleCard;
